import {
    Checkbox,
    Stack,
    TextField,
    PrimaryButton,
    Dropdown,
    DefaultButton,
    Spinner,
    TooltipHost,
    ChoiceGroup,
    ComboBox,
    Panel,
    PanelType,
    CommandBarButton,
    DocumentCard,
    DocumentCardDetails,
    IconButton,
    DatePicker,
    TeachingBubble,
    Layer,
    FontIcon
} from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { MyContext, getUserLanguage } from '../../../../context';
import * as QueryP from '../PolicyQuery';
import * as QueryPR from '../../PolicyRules/PolicyRulesQuery';
import UserPicker from '../../../ReportView/ReportConfiguration/UserPicker';
import { Query } from 'react-apollo';
import _ from 'lodash'
import PolicyCSFolders from "./PolicyCSFolders";
import { queryScorecardsLabels } from '../../AIQualityManagement/AIQualityManagementQuery';
import { queryScorecardLastVersion } from '../../AIQualityManagement/AIQualityManagementQuery';
import AlertNoAddOnCompliance from './AlertNoAddOnCompliance';
import AISupportedLanguages from "../aisupportedlanguages.json";
import AIAssistantQuestionsSelector from '../../AIAssistant/AIAssistantQuestionsSelector';
import { TranscriptLanuages } from '../../../SettingsView/TranscriptLangArr';
import { getCognitiveServicesLocalesTranscription } from "../../../../queries/querySettings";
import { toast } from "react-toastify";
import { json } from 'd3';



const checkboxStyles = () => {
    return {
        root: {
            marginTop: '10px'
        }
    };
};
const listStyles = () => {
    return {
        root: {
            padding: '20px',
            height: '100%'
        }
    };
};

export default class EditPolicy extends Component {

    static contextType = MyContext

    constructor(props) {
        super(props);
        const policy = this.props.data !== undefined ? this.props.data : null
        const policyAlarm = this.props.alarm !== undefined ? this.props.alarm : null

        //policyUsersWOAOC -> users(assignees) from the policy WithOut Add On Compliance license
        const policyUsersWOAOC = policy?.users.filter(u => !(u.addOnCompliance || u.license === "10")).length ?? 0
        const policySupervisorsWOAOC = policy?.supervisors.filter(u => !(u.addOnCompliance || u.license === "10")).length ?? 0

        // selectedUsersAndGroup: set of users and groups'members (no duplicates)
        let selectedUsersAndGroup = policy !== null
            ? [...new Set([
                ...policy.users.map(u => u.userId),
                ...policy.groups.map(g => g?.users.split(',')).flat()
            ])]
            : []
        let metaAssigneeUsersDeleted = policy?.metaAssigneeUsersDeleted ?? []
        let metaUsersThatAreNotInUsersYet = [...metaAssigneeUsersDeleted.filter(metaUser => !selectedUsersAndGroup.find(e => e === metaUser))]
        selectedUsersAndGroup = [...metaUsersThatAreNotInUsersYet, ...selectedUsersAndGroup]

        let selectedAgents = policyAlarm !== null
            ? [...new Set([
                ...policyAlarm.affectedUsers
            ])]
            : []
        let selectedSupervisors = policy !== null ? policy.supervisors.map(u => u.userId) : []
        let metaMonitorUsersDeleted = policy?.metaMonitorUsersDeleted ?? []
        let metaMonitorUsersThatAreNotInUsersYet = metaMonitorUsersDeleted.filter(metaUser => !selectedSupervisors.find(e => e === metaUser))
        selectedSupervisors = [...metaMonitorUsersThatAreNotInUsersYet, ...selectedSupervisors]

        let visibleForUsers = policy !== null ? policy.visibleForUsers.map(u => u.userId) : []

        this.state = {
            //user data, information regarding add on compliance, this state is populated by its child userPicker
            userdata: null,
            //page data\
            processing: false,
            processingVersion: false,
            //policy data
            id: policy !== null ? policy.id : null,
            name: policy !== null ? policy.name : "",
            description: policy !== null ? policy.description : "",
            userId: policy !== null ? policy.userId : null,
            tenantId: policy !== null ? policy.tenantId : null,
            channel: policy !== null ? policy.channel : "None",
            channelList: policy !== null ? policy.channelList : [],
            riskRating: policy !== null ? policy.riskRating : "None",
            active: policy !== null ? policy.active : false,
            aILanguageAnswer: policy != null ? policy.aILanguageAnswer : "None",
            selectedPolicyRule: policy !== null
                ? policy?.basedOn !== "PolicyRule" ?? null
                    ? []
                    : (policy.policyRules[0].masterItemId != null
                        ? policy.policyRules[0].masterItemId
                        : policy.policyRules[0].id)
                : [],
            selectedSupervisors,
            visibleForUsers,
            selectedUsersAndGroup,
            version: policy !== null ? policy.version : 0,
            masterItemId: policy !== null ? policy.masterItemId : null,
            selected: policy !== null ? policy.selected : true,
            //versions
            selectedOtherVersion: false,
            selectedVersion: policy !== null ? policy.id : null,
            allAssigneeHaveAOC: !metaAssigneeUsersDeleted.length,
            allMonitorsHaveAOC: !metaMonitorUsersDeleted.length,
            allVisibleForUsersHaveAOC: true,
            //number of users in the picker bordered with red (without AOC), useful for bulk deleting from message Bar
            deleteNoAOCUsersBulk: metaUsersThatAreNotInUsersYet.length + policyUsersWOAOC,
            deleteNoAOCUsersBulkMonitor: metaMonitorUsersThatAreNotInUsersYet.length + policySupervisorsWOAOC,
            metaMonitorUsersDeleted: policy?.metaMonitorUsersDeleted ?? [],
            conversationSafeFolders: policy?.conversationSafeFolders.map(e => e.id) ?? [],
            basedOn: policy?.basedOn ?? "PolicyRule",
            aICategorizationId: policy !== null && policy.aICategorizationInfos !== null && policy.aICategorizationInfos.length > 0 ? policy.aICategorizationInfos[0].aICategorizationId : "",
            AICatOccurrences: policy !== null && policy.aICategorizationInfos !== null && policy.aICategorizationInfos.length > 0 ? policy.aICategorizationInfos[0].occurrences : 0,
            scorecardId: policy !== null && policy.aIScorecardInfos !== null && policy.aIScorecardInfos.length > 0 ? policy.aIScorecardInfos[0].scorecardId : null,
            conversationType: policy !== null && policy.aIScorecardInfos !== null && policy.aIScorecardInfos.length > 0 ? policy.aIScorecardInfos[0].conversationType : [],
            //policy ai language data
            browserDefaultLanguage: getUserLanguage(),
            languageOptions: AISupportedLanguages.languages,
            aIAssistantSelectedQuestions: policy !== null && policy.aIAssistantQuestions !== null && policy.aIAssistantQuestions.length > 0 ? policy.aIAssistantQuestions.map(q => { return q.masterItemId }) : [],
            aIQuestionType: "AIAssistantQuestion",
            cuTranscriptLanguage: policy !== null && policy.cuTranscriptLanguage !== null ? policy.cuTranscriptLanguage : "en-US",
            cuOptionAlternativeLanguageKey: policy !== null && policy.cuOptionAlternativeLanguageKey !== undefined && policy.cuOptionAlternativeLanguageKey !== null && policy.cuOptionAlternativeLanguageKey !== "" ? policy.cuOptionAlternativeLanguageKey.split(',') : [],
            maxAlternativeLanguages: 3,
            cuAlternativeLanguage: policy !== null ? policy.cuAlternativeLanguage : false,
            isJsonPanelOpen: false, // Zustand f�r das �ffnen/Schlie�en des Panels
            hitAction: policy !== null && policy.hitAction !== null ? policy.hitAction : null,
            alertsEnabled: policyAlarm !== null ? true : false,
            alarmId: policyAlarm !== null ? policyAlarm.id : null,
            alarmAgents: policyAlarm !== null ? (policyAlarm.affectedUsers !== null && policyAlarm.affectedUsers.length > 0 ? "perAgent" : "allAgents") : "allAgents",
            selectedAgents,
            scorecardAlarmSettingItems: [],
            scorecardAlarmSections: [],
            alarmScoreValue: policyAlarm !== null ? policyAlarm.scorecardSettingValue : null,
            alarmScoreName: policyAlarm !== null ? policyAlarm.scorecardSettingName : null,
            selectedSection: null,
            alarmSection: null,
            alarmSections: policyAlarm !== null ? policyAlarm.sectionRules
                .filter(rule => !rule.exclude)
                .map((rule, index) => ({
                    key: index,
                    text: rule.sectionId,
                    minScore: rule.threshold.scorecardSettingValue
                })) : [],
            periodChoices: [],
            alarmPeriodSelection: policyAlarm !== null && policyAlarm.schedule !== null ? policyAlarm.schedule.frequency : (policyAlarm !== null && policyAlarm.schedule === null ? "once" : ""),
            selectedStartDate: policyAlarm !== null && policyAlarm.schedule !== null && policyAlarm.schedule.start !== null ? new Date(policyAlarm.schedule.start) : null,
            selectedEndDate: policyAlarm !== null && policyAlarm.schedule !== null && policyAlarm.schedule.end !== null ? new Date(policyAlarm.schedule.end) : null,
            alarmDayChoices: [],
            dayChoice: policyAlarm !== null && policyAlarm.schedule !== null ? policyAlarm.schedule.dayOfWeek : null,
            agentsToNotify: policyAlarm !== null ? policyAlarm.notification.users : [],
            showTeachingBubbleSave: false,
            showTeachingBubbleScorecardDropdown: false,
            preSelectedbasedOn: null,
            preSelectedScorecard: null
        };
        if (policy !== null && policy.cuJsonInput !== null && policy.cuJsonInput !== undefined) {
            let decodedInput = "";
            try {
                decodedInput = atob(policy.cuJsonInput);
                this.state.cuJsonInput = decodedInput;
            } catch (e) {
                this.state.cuJsonInput = policy.cuJsonInput;
            }
        } else {
            this.state.cuJsonInput = "";
        }
    }

    componentDidMount() {
        this.refreshVersions();

        //get language from context
        const { language } = this.context;
        this.setState({
            browserDefaultLanguage: language,
            aILanguageAnswer: this.getAILanguageAnswer(this.state.languageOptions, language),
            periodChoices: [...this.state.periodChoices,
            { "key": "once", "text": this.context.getTranslation("compliance", "scheduleOnce") },
            { "key": "daily", "text": this.context.getTranslation("compliance", "scheduleDaily") },
            { "key": "weekly", "text": this.context.getTranslation("compliance", "scheduleWeekly") },
            { "key": "monthly", "text": this.context.getTranslation("compliance", "scheduleMonthly") },
            ],
            alarmDayChoices: [...this.state.alarmDayChoices,
            {
                key: 'monday',
                text: this.context.getTranslation("compliance", "monday"),
                styles: { field: { fontWeight: '400' } }
            },
            {
                key: 'tuesday',
                text: this.context.getTranslation("compliance", "tuesday"),
                styles: { field: { fontWeight: '400' } }
            },
            {
                key: 'wednesday',
                text: this.context.getTranslation("compliance", "wednesday"),
                styles: { field: { fontWeight: '400' } }
            },
            {
                key: 'thursday',
                text: this.context.getTranslation("compliance", "thursday"),
                styles: { field: { fontWeight: '400' } }
            },
            {
                key: 'friday',
                text: this.context.getTranslation("compliance", "friday"),
                styles: { field: { fontWeight: '400' } }
            },
            {
                key: 'saturday',
                text: this.context.getTranslation("compliance", "saturday"),
                styles: { field: { fontWeight: '400' } }
            },
            {
                key: 'sunday',
                text: this.context.getTranslation("compliance", "sunday"),
                styles: { field: { fontWeight: '400' } }
            }]
        });



        if (this.state.basedOn === "PolicyRule") {
            // new policy rule policy (or an existing one without a saved language) - None.
            // existing policy rule policy that has a saved language - keep showing it (RI-18867).
            if (this.props.data === undefined || this.state.aILanguageAnswer === "None" || !this.state.aILanguageAnswer) {
                this.setState({ aILanguageAnswer: "None" })
            }
            else {
                this.setState({ aILanguageAnswer: this.getAILanguageAnswer(this.state.languageOptions, this.state.browserDefaultLanguage) })
            }
        }
        else if (this.state.basedOn === "Scorecard" || this.state.basedOn === "AICategorization" || this.state.basedOn === "AIAssistant" || this.state.basedOn === "ContentUnderstanding") {
            let language = this.getAILanguageAnswer(this.state.languageOptions, this.state.browserDefaultLanguage);
            this.setState({ aILanguageAnswer: language })
        }
        else {
            this.setState({ aILanguageAnswer: "None" })
        }

        if (this.state.basedOn === "Scorecard") {
            this.onChangeSelectedScorecard();
        }



    }

    componentDidUpdate(prevProps, prevState) {
        let oldScorecardId = prevState.scorecardId
        if ((this.state.scorecardId !== prevState.scorecardId) && (this.state.scorecardId !== null && prevState.scorecardId === null)) {
            this.onChangeSelectedScorecard(oldScorecardId);
        }
        if (this.state.alertsEnabled && (prevState.basedOn === "Scorecard" && prevState.basedOn !== this.state.basedOn)) {
            this.resetAlarm();
        }
        else if (this.state.alertsEnabled && (prevState.basedOn === "Scorecard" && prevState.scorecardId !== this.state.scorecardId)) {
            this.resetAlarm();
            this.onChangeSelectedScorecard()
        }

        if (!this.state.alertsEnabled && prevState.alertsEnabled) {
            this.resetAlarm();
        }

    }

    refetchQueryVersions = null;
    numberOfVersions = 1

    refreshVersions = () => {
        if (this.refetchQueryVersions !== null) {
            this.refetchQueryVersions()
        }
    }

    resetAlarm = () => {
        this.setState({
            alertsEnabled: false,
            alarmAgents: "allAgents",
            selectedAgents: [],
            alarmScoreValue: null,
            alarmSections: [],
            selectedSection: null,
            alarmPeriodSelection: "",
            selectedStartDate: null,
            selectedEndDate: null,
            dayChoice: [],
            agentsToNotify: [],
        })
    }

    changeName = (e, value) => {
        this.setState({
            name: value,
            selectedOtherVersion: false,
        })
    }

    changeDescription = (e, value) => {
        this.setState({
            description: value,
            selectedOtherVersion: false,
        })
    }

    changeHitAction = (e, value) => {
        this.setState({
            hitAction: value,
            selectedOtherVersion: false,
        })
    }


    onChangeText = () => {
        let channel = ""
        switch (this.state.channel) {
            case "Text": channel = "None"; break;
            case "None": channel = "Text"; break;
            case "Both": channel = "Voice"; break;
            case "Voice": channel = "Both"; break;
        }
        this.setState({
            channel,
            selectedOtherVersion: false,
        })
    }

    onChangeRiskRating = (ev) => {
        let riskRating = ""
        switch (ev.target.id) {
            case "Info": riskRating = "Info"; break;
            case "Adherence": riskRating = "Adherence"; break;
            case "Warning": riskRating = "Warn"; break;
        }
        this.setState({
            riskRating,
            selectedOtherVersion: false,
        })
    }

    onChangeVoice = () => {
        let channel = ""
        switch (this.state.channel) {
            case "Text": channel = "Both"; break;
            case "None": channel = "Voice"; break;
            case "Both": channel = "Text"; break;
            case "Voice": channel = "None"; break;
        }
        this.setState({
            channel,
            selectedOtherVersion: false,
        })
    }

    onChangeChannel = (event, checked, channelType) => {

        let channelList = []

        // if channelList is empty we are editing an old policy with 2 old channels
        if (this.state.channelList == null || this.state.channelList === undefined) {
            if (checked) {
                if (channelType != this.state.channel && this.state.channel == "Both") {
                    channelList.push("Text");
                    channelList.push("Voice");
                    channelList.push(channelType);
                }
                else if (channelType != this.state.channel) {
                    channelList.push(this.state.channel);
                    channelList.push(channelType);
                }
            }
            else if (!checked) {
                if (this.state.channel == "Both" && channelType == "Text") {
                    channelList.push("Voice");
                }
                else if (this.state.channel == "Both" && channelType == "Voice") {
                    channelList.push("Text");
                }

            }
            this.setState({ channelList })
        }
        else {
            if (checked && !this.state.channelList.includes(channelType)) {
                channelList = [... this.state.channelList, channelType]
                this.setState({ channelList })
            }
            else if (!checked && this.state.channelList.includes(channelType)) {
                channelList = this.state.channelList.filter((item) => item !== channelType)
                this.setState({ channelList })
            }
        }
    }

    convertChannel = () => {

        let channelList = []

        switch (this.state.channel) {
            case "Text":
                channelList.push("Text");
                break;
            case "Voice":
                channelList.push("Voice");
                break;
            case "Both":
                channelList.push("Text");
                channelList.push("Voice");
                break;
            case "Mail":
                channelList.push("Mail");
        }

        return channelList;
    };

    onChangeActive = () => {
        this.setState({
            active: !this.state.active,
            selectedOtherVersion: false,
        })
    }

    onChangeSelectedScorecard = (oldScorecardId) => {
        let id = this.state.scorecardId
        this.props.apol
            .query({
                query: queryScorecardLastVersion,
                variables: { id }
            })
            .then(({ loading, error, data, refetch }) => {
                let newScorecard = data.getScorecardLastVersion;
                if (this.props.alarm === undefined || (oldScorecardId && oldScorecardId !== this.state.scorecardId)) {
                    this.setState({
                        alarmScoreValue: newScorecard.settingItems != null ? newScorecard.settingItems[0].minRange : "",
                        alarmScoreName: `${newScorecard.settingItems != null ? newScorecard.settingItems[0].name : ""} (${newScorecard.settingItems != null ? newScorecard.settingItems[0].minRange : ""}% - ${newScorecard.settingItems != null ? newScorecard.settingItems[0].maxRange : ""}%)`,
                        scorecardAlarmSections: newScorecard.sections?.map((s, index) => {
                            return {
                                "key": index,
                                "text": s.name
                            }
                        }),
                        scorecardAlarmSettingItems: newScorecard.settingItems?.map(item => {
                            return {
                                "key": item.minRange,
                                "text": `${item.name} (${item.minRange}% - ${item.maxRange}%)`
                            }
                        })
                    })
                }
                else {
                    this.setState({
                        scorecardAlarmSections: newScorecard.sections.map((s, index) => {
                            return {
                                "key": index,
                                "text": s.name
                            }
                        }),
                        scorecardAlarmSettingItems: newScorecard.settingItems.map(item => {
                            return {
                                "key": item.minRange,
                                "text": `${item.name} (${item.minRange}% - ${item.maxRange}%)`
                            }
                        })
                    })
                }

            });




    }

    onChangeSelectPolicyRule = (e, item) => {
        this.setState({
            selectedPolicyRule: item.key,
            selectedOtherVersion: false,
        })
    }

    onChangePolicyFolders = (newSelection) => {
        this.setState({ conversationSafeFolders: newSelection, selectedOtherVersion: false })
    }

    onChangeAIAssistantQuestions = (newSelection) => {
        this.setState({ aIAssistantSelectedQuestions: newSelection })
    }

    onChangePeriod = (e, item) => {
        this.setState({
            alarmPeriodSelection: item.key
        })
    }

    checkAlarmEnabled = () => {
        // teaching bubble not required if policy is being created for the first time
        (this.state.alertsEnabled && this.props.data !== undefined) ? this.setState({ showTeachingBubbleSave: true }) : this.save()
    }

    checkBasedOn = (option) => {
        if (this.state.alertsEnabled) {
            this.setState({ showTeachingBubbleBasedOn: true, preSelectedbasedOn: option.key })
        }
        else {
            this.setState({
                basedOn: option.key,
                aILanguageAnswer: option.key === 'PolicyRule' ? "None" : this.getAILanguageAnswer(this.state.languageOptions, this.state.browserDefaultLanguage),
                riskRating: option.key === 'Scorecard' ? "None" : this.state.riskRating,
                selectedOtherVersion: false
            })
        }
    }

    checkScorecard = (newScorecardId) => {
        if (this.state.alertsEnabled && this.state.scorecardId !== newScorecardId) {
            this.setState({
                showTeachingBubbleScorecardDropdown: true,
                preSelectedScorecard: newScorecardId
            })
        }
        else {
            this.setState({
                scorecardId: newScorecardId,
                selectedOtherVersion: false,
            })
        }
    }

    checkAlerts = () => {
        if (this.state.alertsEnabled) {
            this.setState({
                showTeachingBubbleCheckbox: true
            })
        }
        else {
            this.setState({
                alertsEnabled: !this.state.alertsEnabled
            })
        }
    }
    addSection = () => {
        const newSection = this.state.alarmSection;

        const alreadyExists = this.state.alarmSections.some(
            section => section.key === newSection.key
        );

        if (!alreadyExists) {
            this.setState(prevState => ({
                alarmSections: [...prevState.alarmSections, { ...newSection, minScore: this.state.scorecardAlarmSettingItems[0].key }],
                selectedSection: null
            }));
        }
    }

    deleteSection = (sectionToDelete) => {
        this.setState(prevState => ({
            alarmSections: prevState.alarmSections.filter(
                section => section.key !== sectionToDelete
            )
        }));
    };

    /*Buttons cancel and save*/

    cancel = () => {
        this.props.closePanel()
    }

    // if state cuJsonInput is not empty encode with btoa
    // else set state cuJsonInput to null

    save = () => {
        // if state cuJsonInput is not empty or null or undefined encode with btoa
        // else set state cuJsonInput to null
        let jsonInput = null;
        let aIAssistantQuestions = (this.state.basedOn === "AIAssistant" || this.state.basedOn === "ContentUnderstanding") ?
            this.state.aIAssistantSelectedQuestions.map(question => { return ({ id: question }) }) : [];
        if (this.state.cuJsonInput !== null && this.state.cuJsonInput !== undefined && this.state.cuJsonInput !== "") {
            jsonInput = btoa(this.state.cuJsonInput)
            aIAssistantQuestions = [{ id: "JSON" }];
        }

        this.setState({ processing: true })
        const auth = this.props.auth
        const policy = {
            id: this.state.id,
            name: this.state.name.trim(),
            description: this.state.description,
            channel: null,
            channelList: this.state.channelList == null || this.state.channelList === undefined
                ? this.convertChannel()
                : this.state.channelList,
            riskRating: this.state.riskRating,
            active: this.state.active,
            userId: this.state.userId,
            tenantId: this.state.tenantId,
            supervisors: this.state.selectedSupervisors.map(userIdOrGroupId => { return ({ userId: userIdOrGroupId }) }),
            aILanguageAnswer: this.state.aILanguageAnswer,
            policyRules: this.state.selectedPolicyRule.length ? [
                {
                    id: this.state.selectedPolicyRule,
                    masterItemId: this.state.selectedPolicyRule
                }
            ] : [],
            //FIXME: for now all users and groups are stored here in users
            users: this.state.selectedUsersAndGroup.map(userIdOrGroupId => ({ userId: userIdOrGroupId })),
            visibleForUsers: this.state.visibleForUsers.map(userIdOrGroupId => ({ userId: userIdOrGroupId })),
            metaAssigneeUsersDeleted: [],
            metaMonitorUsersDeleted: this.state.metaMonitorUsersDeleted,
            //manage version
            version: this.numberOfVersions,
            masterItemId: this.state.masterItemId,
            selected: this.state.selected,
            //managed conversationSafeFolders
            conversationSafeFolders: this.state?.conversationSafeFolders?.map(id => ({ id })) ?? [],
            basedOn: this.state.basedOn,
            aICategorizationInfos: this.state.basedOn === "AICategorization" ? [{
                aICategorizationId: this.state?.aICategorizationId,
                occurrences: parseInt(this.state.AICatOccurrences)
            }] : [],
            aIScorecardInfos: this.state.basedOn === "Scorecard" ? [{
                scorecardId: this.state.scorecardId,
                conversationType: this.state.conversationType
            }] : [],
            aIAssistantQuestions: aIAssistantQuestions,
            cuTranscriptLanguage: this.state.cuTranscriptLanguage,
            cuOptionAlternativeLanguageKey: this.state.cuOptionAlternativeLanguageKey.join(','),
            cuAlternativeLanguage: this.state.cuAlternativeLanguage,
            cuJsonInput: jsonInput,
            hitAction: this.state.hitAction
        }

        if (!this.state.alertsEnabled) {
            this.props.apol
                .mutate({
                    mutation: QueryP.createPolicy,
                    variables: { auth, policy }
                })
                .then((result) => {
                    this.setState({ processing: false })
                    if (result.data.createPolicy.status === "ok") {
                        if (this.props.alarm !== undefined && this.props.alarm.id !== null && this.props.data.id && result.data.createPolicy.id === this.props.data.id) {
                            let id = this.props.alarm.id
                            this.props.apol
                                .mutate({
                                    mutation: QueryP.deletePolicyAlarm,
                                    variables: { id }
                                })
                                .then((result) => {
                                    if (result.data.deletePolicyAlarm.status === "ok") {
                                        this.props.closePanel()
                                        this.props.refreshPolicies()
                                    }
                                    else {
                                        this.props.setMessageError(this.context.getTranslation("compliance", result.data.deletePolicyAlarm.text))
                                    }
                                });
                        } else {
                            this.props.closePanel()
                            this.props.refreshPolicies()
                        }
                    } else {
                        this.props.setMessageError(this.context.getTranslation("compliance", result.data.createPolicy.text))
                    }
                });
        }
        else {
            this.props.apol
                .mutate({
                    mutation: QueryP.createPolicy,
                    variables: { auth, policy }
                })
                .then((result) => {
                    if (result.data.createPolicy.status === "ok") {
                        this.props.setMessageError(this.context.getTranslation("compliance", result.data.createPolicy.text))
                        const policyAlarm =
                        {
                            id: this.props.data !== undefined ? (result.data.createPolicy.id !== this.props.data.id ? null : this.state.alarmId) : null,
                            policyId: result.data.createPolicy.id,
                            objectReferenceId: this.state.scorecardId,
                            sectionRules: this.setSectionRules(),
                            affectedUsers: this.state.selectedAgents,
                            scorecardSettingName: this.state.alarmScoreName,
                            scorecardSettingValue: this.state.alarmScoreValue,
                            schedule: this.state.alarmPeriodSelection == "once" ? null :
                                {
                                    start: (() => {
                                        const date = new Date(this.state.selectedStartDate);
                                        date.setHours(12, 0, 0, 0);
                                        return date.toISOString();
                                    })(),
                                    end: this.state.selectedEndDate !== null ? (() => {
                                        const date = new Date(this.state.selectedEndDate);
                                        date.setHours(12, 0, 0, 0);
                                        return date.toISOString();
                                    })() : null,
                                    frequency: this.state.alarmPeriodSelection,
                                    dayOfWeek: this.state.alarmPeriodSelection == "weekly" ? this.state.dayChoice : ""
                                },
                            notification: {
                                users: this.setAgentsToNotify(),
                                conversationToDo: true
                            }
                        }
                        this.props.apol
                            .mutate({
                                mutation: QueryP.createPolicyAlarm,
                                variables: { auth, policyAlarm }
                            })
                            .then((result) => {
                                this.setState({ processing: false })
                                if (result.data.upsertPolicyAlarm.status === "ok") {
                                    this.props.closePanel()
                                    this.props.refreshPolicies()
                                } else {
                                    this.props.setMessageError(this.context.getTranslation("compliance", result.data.createPolicy.text))
                                }
                            });
                    } else {
                        this.setState({ processing: false })
                    }

                });


        }
    }

    //form validation -> disable save button with this method
    isValid = () => {
        const name = this.state.name.trim() !== ""
        const assignTo = this.state.basedOn === "ContentUnderstanding" ? true : this.state.selectedUsersAndGroup.length > 0
        const channel = this.state.channel !== "None" || (this.state.channelList.length > 0)
        const riskRating = this.state.basedOn === "ContentUnderstanding" ? true : this.state.riskRating !== ""
        let basedOnCheck = false
        switch (this.state.basedOn) {
            case "PolicyRule": {
                basedOnCheck = this.state.basedOn !== "PolicyRule" ? true : this.state.selectedPolicyRule.length > 0
                break;
            }
            case "AICategorization": {
                const AICatSectionFilled = this.state.basedOn !== "AICategorization" ? true :
                    this.state.aICategorizationId !== "" && (_.inRange(this.state?.AICatOccurrences, 1, 21))
                basedOnCheck = AICatSectionFilled
                break;
            }
            case "Scorecard": {
                basedOnCheck = this.state.scorecardId !== null
                break;
            }
            case "AIAssistant": {
                basedOnCheck = this.state.aIAssistantSelectedQuestions !== null && this.state.aIAssistantSelectedQuestions.length > 0
                break;
            }
            case "ContentUnderstanding": {
                basedOnCheck = this.state.aIAssistantSelectedQuestions !== null
                break;
            }
            default: break;
        }

        const allSelectedUsersHaveAOC = this.state.selectedUsersAndGroup.reduce((acc, cur) => {
            const user = this.state?.userdata?.find(e => e.id == cur);
            return acc && (user?.addOnCompliance === true || user?.license === "10");
        }, true);

        const allSelectedMonitorsHaveAOC = this.state.selectedSupervisors.reduce((acc, cur) => {
            const user = this.state?.userdata?.find(e => e.id == cur);
            return acc && (user?.addOnCompliance === true || user?.license === "10");
        }, true);

        const policyAlarmCheck = this.checkAlarmConditions()

        return name && assignTo && channel && riskRating && basedOnCheck && allSelectedUsersHaveAOC && allSelectedMonitorsHaveAOC && policyAlarmCheck
    }

    checkAlarmConditions = () => {
        if (this.state.alertsEnabled) {

            const checkAgents = (this.state.alarmAgents == "perAgent") ?
                (this.state.selectedAgents && this.state.selectedAgents.length > 0 ? true : false) : true

            const checkExistingPeriod = this.state.alarmPeriodSelection ? true : false

            const checkPeriodDaily = (this.state.alarmPeriodSelection == "daily") ?
                (this.state.selectedStartDate || this.state.selectedEndDate ? true : false) : true

            const checkPeriodWeekly = (this.state.alarmPeriodSelection == "weekly") ?
                ((this.state.selectedStartDate || this.state.selectedEndDate) && this.state.dayChoice ? true : false) : true

            const checkPeriodMonthly = (this.state.alarmPeriodSelection == "monthly") ?
                (this.state.selectedStartDate ? true : false) : true

            const checkDates = (this.state.selectedStartDate && this.state.selectedEndDate) ?
                (this.state.selectedStartDate <= this.state.selectedEndDate ? true : false) : true

            const checkAgentsToNotify = this.state.agentsToNotify && this.state.agentsToNotify.length > 0 ? true : false

            return checkAgents && checkExistingPeriod && checkPeriodDaily && checkPeriodWeekly && checkPeriodMonthly && checkDates && checkAgentsToNotify

        }

        return true
    }

    setSectionRules = () => {
        const rulesList = []


        if (this.state.alarmSections && this.state.alarmSections.length > 0) {
            this.state.scorecardAlarmSections.forEach((section) => {

                let alarmSection = this.state.alarmSections.find(alarmSect => section.text == alarmSect.text)
                let rule = null;

                if (alarmSection !== null && alarmSection !== undefined) {
                    let ruleSetting = this.state.scorecardAlarmSettingItems.find(setting => alarmSection.minScore == setting.key)

                    rule = {
                        sectionId: alarmSection.text, exclude: false, threshold: { scorecardSettingName: ruleSetting.text, scorecardSettingValue: ruleSetting.key }
                    }
                }
                else {
                    rule = { sectionId: section.text, exclude: true, threshold: null }
                }

                rulesList.push(rule)

            });
            return rulesList
        }

        return null
    }

    setAgentsToNotify = () => {
        const agents = []

        this.state.agentsToNotify.forEach((user) => {
            let agent = null

            agent = { userId: user.userId, email: user.email }
            agents.push(agent)
        })

        return agents
    }

    availableAlternativeLanguages = (languageList) => {

        let alternativeLanguageList = [];

        languageList.map((language) => {
            if (language.key != this.state.cuTranscriptLanguage) {
                alternativeLanguageList.push(language);
            }
        });

        return alternativeLanguageList;
    }

    onChangeMultiLanguages = (event, option, index, value) => {
        const currentSelectedKeys = this.state.cuOptionAlternativeLanguageKey || [];
        if (option) {
            // User selected/de-selected an existing option
            const tmp = this.updateSelectedOptionKeysAltLanguages(currentSelectedKeys, option);

            this.setState({
                cuOptionAlternativeLanguageKey: tmp
            });
        }
    }

    updateSelectedOptionKeysAltLanguages = (selectedKeys, option) => {
        selectedKeys = [...selectedKeys]; // modify a copy
        const index = selectedKeys.indexOf(option.key);
        //check if selected keys array has more than max alternative languages allowed
        //if true - will not let user to check new if another option is deselected
        if ((selectedKeys.length >= this.state.maxAlternativeLanguages) && option.selected && (index < 0)) {
            option.selected = "false";
            //tofix where is the localization?
            toast.error("Maximum " + this.state.maxAlternativeLanguages + " language" + (this.state.maxAlternativeLanguages > 1 ? "s" : "") + " allowed", { autoClose: 5000, position: "top-left" });
        } else {
            if (option.selected && index < 0) {
                selectedKeys.push(option.key);
            } else {
                selectedKeys.splice(index, 1);
            }
        }
        return selectedKeys;
    };

    onChangeVersion = (e, item) => {
        //get specific version to fill the fields
        this.setState({ processingVersion: true })
        let id = item.key
        let auth = this.props.auth
        this.props.apol
            .query({
                query: QueryP.queryPolicy,
                variables: { auth, id }
            })
            .then(({ loading, error, data, refetch }) => {
                let oldVersion = data.getPolicy;
                this.setState({
                    name: oldVersion.name,
                    description: oldVersion.description,
                    userId: oldVersion.userId,
                    channel: oldVersion.channel,
                    channelList: oldVersion.channelList,
                    riskRating: oldVersion.riskRating,
                    active: oldVersion.active,
                    selectedPolicyRule: oldVersion !== null && oldVersion.policyRules.length > 0
                        ? (oldVersion.policyRules[0].masterItemId != null
                            ? oldVersion.policyRules[0].masterItemId
                            : oldVersion.policyRules[0].id)
                        : [],
                    selectedSupervisors: oldVersion.supervisors.map(u => u.userId),
                    selectedUsersAndGroup: [...oldVersion.users.map(u => u.userId), ...oldVersion.groups.map(g => g.id)],
                    visibleForUsers: oldVersion.visibleForUsers.map(u => u.userId),
                    tenantId: oldVersion.tenantId,
                    selectedVersion: id,
                    selectedOtherVersion: true,
                    processingVersion: false,
                    metaAssigneeUsersDeleted: oldVersion.metaMonitorUsersDeleted,
                    metaMonitorUsersDeleted: oldVersion.metaMonitorUsersDeleted,
                    conversationSafeFolders: oldVersion?.conversationSafeFolders.map(e => e.id) ?? [],
                    basedOn: oldVersion.basedOn,
                    aICategorizationId: oldVersion.aICategorizationInfos !== null && oldVersion.aICategorizationInfos.length > 0 ? oldVersion.aICategorizationInfos[0].aICategorizationId : "",
                    AICatOccurrences: oldVersion.aICategorizationInfos !== null && oldVersion.aICategorizationInfos.length > 0 ? oldVersion.aICategorizationInfos[0].occurrences : 0,
                    scorecardId: oldVersion.aIScorecardInfos !== null && oldVersion.aIScorecardInfos.length > 0 ? oldVersion.aIScorecardInfos[0].scorecardId : null,
                    conversationType: oldVersion.aIScorecardInfos !== null && oldVersion.aIScorecardInfos.length > 0 ? oldVersion.aIScorecardInfos[0].conversationType : [],
                    aIAssistantSelectedQuestions: oldVersion.aIAssistantQuestions !== null && oldVersion.aIAssistantQuestions.length > 0 ? oldVersion.aIAssistantQuestions.map(q => { return q.masterItemId }) : [],
                    hitAction: oldVersion.hitAction,
                })
            });
    }

    onChangeMinAlarmScore = (e, item) => {
        let alarmScoreValue = item.key;
        let alarmScoreName = this.state.scorecardAlarmSettingItems.find(item => item.key === alarmScoreValue).text;

        this.setState({
            alarmScoreValue, alarmScoreName
        })
    }

    onChangeScoreSelectedSection = (cardKey, item) => {
        this.setState(prevState => ({
            alarmSections: prevState.alarmSections.map(section =>
                section.key === cardKey
                    ? { ...section, minScore: item.key }
                    : section
            )
        }));
    }

    onChangeSection = (e, item) => {
        this.setState({
            selectedSection: item.key,
            alarmSection: item
        })
    }

    onChangePolicyFolders = (newSelection) => {
        this.setState({ conversationSafeFolders: newSelection, selectedOtherVersion: false })
    }

    getAILanguageAnswer(languageOptions, browserDefaultLanguage) {
        if (this.state.aILanguageAnswer === "None") {
            // set AI Lang answer as the browser language when adding new policy
            return this.getLanguageFromJSON(languageOptions, browserDefaultLanguage)
        }
        else {
            // otherwise use the default returned from backend
            return this.getLanguageFromJSON(languageOptions, this.state.aILanguageAnswer)
        }
    }

    getLanguageFromJSON(languageOptions, languageCode) {
        if (languageCode == "") {
            return this.context.getTranslation("compliance", "aIAssistantAutoDetectLanguage")
        }
        let language = languageOptions.find((language) => language.key?.toLowerCase() === languageCode?.toLowerCase());

        if (language) {
            // if is used the browser default language while adding a new policy
            return language.text
        }
        else {
            language = languageOptions.find((language) => language.text?.toLowerCase() === languageCode?.toLowerCase());
            if (language) {
                // if editing an existing policy - searching in the json by language name
                return language.text
            }
            else {
                // if a non existing language or code is passed
                language = languageOptions.find((language) => language.text.toLowerCase() === "english")
                return language.text
            }

        }
    }

    handleLanguageChange = (event, option) => {
        if (option.key == "-1") {
            this.setState({
                aILanguageAnswer: "",
            });
        }
        else {
            this.setState({ aILanguageAnswer: option.text })
        }
    }

    restoreVersion = () => {
        this.setState({ processing: true })
        //restorePolicy -> id vesrion to restore
        let id = this.state.selectedVersion
        this.props.apol
            .mutate({
                mutation: QueryP.restorePolicy,
                variables: { id }
            })
            .then((result) => {
                if (result.data.restorePolicy.status === "ok") {
                    this.props.closePanel()
                    this.props.refreshPolicies()
                } else {
                    this.props.setMessageError(this.context.getTranslation("compliance", result.data.restorePolicy.text))
                }
                this.setState({
                    selectedOtherVersion: false,
                    processing: false
                })
            });
    }

    wrapWithInfoTooltip = function(rs, align, subrender){
		return <div style={{ display: 'flex', flexDirection: 'row', alignItems: align ?? 'anchor-center'}}>
				{subrender}
				<TooltipHost content={this.context.getTranslation("compliance", rs)} styles={{ root:{ zIndex: 5000} }} >
					<FontIcon aria-label="Compass" iconName="Info" style={{ color: this.props.theme.palette.black, marginTop: '5px', marginLeft: '5px', cursor: 'pointer' }} />
				</TooltipHost>
			</div>
	}

    basedOnOpt = () => {
        var opt =
            [
                {
                    key: 'PolicyRule',
                    text: this.context.getTranslation("compliance", "policyRuleCheck"),
                    styles: { field: { fontWeight: '400' } }
                },
                {
                    key: 'AICategorization',
                    text: this.context.getTranslation("compliance", "autocatagorizationAI"),
                    styles: { field: { fontWeight: '400' } }
                }
            ]
        if (this.props.userRules.addOnQualityManagement && this.props.userRules.ruleAccess.userComplianceQM) {
            opt = [...opt,
            {
                key: 'Scorecard',
                text: this.context.getTranslation("compliance", "scorecard"),
                styles: { field: { fontWeight: '400' } }
            }]
        }
        if (this.props.userRules.ruleAccess.userComplianceAIAssistant) {
            opt = [...opt,
            {
                key: 'AIAssistant',
                text: this.context.getTranslation("compliance", "aIAssistant"),
                styles: { field: { fontWeight: '400' } }
            }]
        }

        {
            opt = [...opt,
            {
                key: 'ContentUnderstanding',
                text: this.context.getTranslation("compliance", "contentUnderstanding"),
                styles: { field: { fontWeight: '400' } },
                onRenderField: (props, render) => this.wrapWithInfoTooltip("contentUnderstandingTooltip",undefined,render(props))
            }]
        }

        return opt
    }

    alarmOpt = () => {
        var opt =
            [
                {
                    key: 'allAgents',
                    text: this.context.getTranslation("compliance", "alarmAllAgents"),
                    styles: { field: { fontWeight: '400' } }
                },
                {
                    key: 'perAgent',
                    text: this.context.getTranslation("compliance", "alarmPerAgent"),
                    styles: { field: { fontWeight: '400' } }
                }
            ]

        return opt
    }

    toggleJsonPanel = () => {
        this.setState((prevState) => ({
            isJsonPanelOpen: !prevState.isJsonPanelOpen
        }));
    };


    tooltipProps: ITooltipProps = {
        onRenderContent: () => (
            <div>{this.context.getTranslation("compliance", "aiCategoryTooltip")}</div>
        ),
    };

    render() {
        const numericalSpacingStackTokens = { childrenGap: 15 };
        return (<div>
            {
                this.state.processingVersion && <div>
                    <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                </div>
            }
            {!this.state.processingVersion && <div>
                {/*QUERY ALL VERSIONS*/}
                {this.state.masterItemId !== null && <Query
                    query={QueryP.getAllVersionOfPolicy}
                    variables={{ masterItemId: this.state.masterItemId }}>
                    {({ loading, error, data, refetch }) => {
                        this.refetchQueryVersions = refetch
                        if (loading) {
                            return (<Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />)
                        }
                        if (error || data.getAllVersionOfPolicy == null) {
                            return ""
                        }
                        let versions = data.getAllVersionOfPolicy.map(v => {
                            return {
                                "key": v.id,
                                "text": v.version
                            }
                        })
                        this.numberOfVersions = versions.length
                        return (<div>
                            {versions.length > 0 && <Stack >
                                <Stack.Item>
                                    <Dropdown
                                        label={this.context.getTranslation("compliance", "version")}
                                        selectedKey={this.state.selectedVersion}
                                        onChange={this.onChangeVersion}
                                        options={versions}
                                    />
                                </Stack.Item>
                            </Stack>}
                        </div>
                        )
                    }}
                </Query>}
                <TextField label={this.context.getTranslation("compliance", "name")} value={this.state.name} onChange={this.changeName} required />
                <TextField label={this.context.getTranslation("compliance", "description")} value={this.state.description} onChange={this.changeDescription} />
                {/*BASED ON*/}
                <h5 id="basedOnLabel">{this.context.getTranslation("compliance", "basedOn")}</h5>
                <Stack>
                    <ChoiceGroup
                        style={{ marginBottom: "10px" }}
                        selectedKey={this.state.basedOn}
                        options={this.basedOnOpt()}
                        onChange={(e, option) => this.checkBasedOn(option)}
                    />
                    {/*BASED ON POLICY RULE*/}
                    {this.state.basedOn === "PolicyRule" && <div>
                        <Query query={QueryPR.queryPolicyRuleLabels} fetchPolicy="network-only">
                            {({ loading, error, data }) => {
                                if (loading) return (<Spinner label="Still loading..." ariaLive="assertive" labelPosition="top" />);
                                if (error) return <h4>Failed to connect</h4>;
                                if (data.getPolicyRuleLabels === null) return <div />;
                                const availablePolicyRules = data.getPolicyRuleLabels.map(pr => {
                                    return { key: pr.masterItemId, text: pr.name }
                                })
                                return (
                                    <Dropdown
                                        placeholder={this.context.getTranslation("compliance", "selectPolicyRule")}
                                        selectedKey={this.state.selectedPolicyRule}
                                        onChange={this.onChangeSelectPolicyRule}
                                        options={availablePolicyRules}
                                    />
                                )
                            }}
                        </Query>
                    </div>

                    }
                    {/*BASED ON CATEGORIZATION*/}
                    {this.state.basedOn === "AICategorization" &&
                        <Query
                            query={QueryPR.queryAICategorizationLabels}
                            variables={{}}
                        >
                            {({ loading, error, data }) => {
                                if (loading) return (<Spinner label="Still loading..." ariaLive="assertive" labelPosition="top" />);
                                if (error) return <h4>Failed to connect</h4>;
                                if (data.getAICategorizations == null) return <div />;
                                return <Stack horizontal>
                                    <Stack.Item grow={3}>
                                        <ComboBox
                                            placeholder={this.context.getTranslation("compliance", "selectAICategorization")}
                                            style={{ marginRight: 15 }}
                                            // label={this.context.getTranslation("compliance", "AICategorization")}
                                            selectedKey={this.state.aICategorizationId ?? undefined}
                                            allowFreeform={false}
                                            onChange={(e, i) => {
                                                this.setState({
                                                    aICategorizationId: i.key,
                                                    selectedOtherVersion: false,
                                                })
                                            }}
                                            autoComplete={true}
                                            options={data.getAICategorizations.map(e => ({ text: e.name, key: e.id }))}
                                        />
                                    </Stack.Item>
                                    <Stack.Item align="center" style={{ marginRight: 12 }}>
                                        {this.context.getTranslation("compliance", "max#")}
                                    </Stack.Item>
                                    <Stack.Item>
                                        <TooltipHost content={this.context.getTranslation("compliance", "max#Tooltip")}>
                                            <TextField
                                                id="AICategorizationNumber"
                                                value={this.state?.AICatOccurrences ?? 0}
                                                type="Number"
                                                min={0}
                                                max={20}
                                                errorMessage={(this.state.date < 7) ? "Minimum 7 days allowed" : ""}
                                                onChange={(event, newValue) => {
                                                    this.setState({
                                                        AICatOccurrences: newValue,
                                                        selectedOtherVersion: false,
                                                    });
                                                }}
                                            />
                                        </TooltipHost>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <TooltipHost tooltipProps={this.tooltipProps}>
                                            <FontIcon aria-label="Compass" iconName="Info" style={{ color: this.props.theme.palette.black, marginTop: '3px', marginLeft: '10px', cursor: 'pointer', fontSize: '20px' }} />
                                        </TooltipHost>
                                    </Stack.Item>
                                </Stack>
                            }}
                        </Query>
                    }
                    {/*BASED ON AIASSISTANT*/}
                    {this.state.basedOn === "AIAssistant" &&
                        <AIAssistantQuestionsSelector
                            isFromDetailView={false}
                            automated={true}
                            selectedKeys={this.state.aIAssistantSelectedQuestions}
                            onChangeAIAssistantQuestions={this.onChangeAIAssistantQuestions}
                            hasMultiselect={true}
                            queryOnTemplateGroups={false}
                            hasOpenQuestion={false}
                            aIQuestionType={"AIAssistantQuestion"}
                        />
                    }
                    {/*BASED ON ContentUnderstanding*/}
                    {this.state.basedOn === "ContentUnderstanding" &&
                        <div style={{display: "flex",  flexDirection: "column",  gap: "20px"}}>
                            {/* Text before the AIAssistantQuestionsSelector */}
                            {this.wrapWithInfoTooltip("fieldsOrSchemaTooltip",undefined,(<h5>{this.context.getTranslation("compliance", "fieldsOrSchema")}</h5>))}
                              <AIAssistantQuestionsSelector
                                   isFromDetailView={false}
                                   automated={false}
                                   selectedKeys={this.state.aIAssistantSelectedQuestions}
                                   onChangeAIAssistantQuestions={this.onChangeAIAssistantQuestions}
                                   hasMultiselect={true}
                                   queryOnTemplateGroups={false}
                                   hasOpenQuestion={false}
                                   aIQuestionType={"CUQuestion"}
                                   disabled={this.state.cuJsonInput !== ""}
                              />
                            {/* Button zum �ffnen des Panels */}
                            <PrimaryButton
                                text={this.context.getTranslation("compliance", "fieldschema")}
                                onClick={this.toggleJsonPanel}
                                style={{ marginBottom: '20px' }}
                                disabled={this?.state?.aIAssistantSelectedQuestions?.length > 0 }
                            />
                            {/* Panel f�r JSON-Eingabe */}
                            <Panel
                                isOpen={this.state.isJsonPanelOpen}
                                onDismiss={this.toggleJsonPanel}
                                headerText={this.context.getTranslation("compliance", "fieldschema")}
                                closeButtonAriaLabel={this.context.getTranslation("common", "close")}
                                type={PanelType.extraLarge} // Gr��e des Panels
                                styles={{ content: { overflowY: 'auto' } }} // Scrollable content
                            >
                                <TextField
                                    label=""
                                    multiline
                                    rows={20}
                                    value={this.state.cuJsonInput}
                                    onChange={(e, newValue) => this.setState({ cuJsonInput: newValue })}
                                    styles={{
                                        root: { height: '100%' },
                                        field: { height: 'calc(100vh - 200px)', overflow: 'auto' } // Dynamische H�he
                                    }}
                                />
                                <DefaultButton
                                    text={this.context.getTranslation("common", "close")}
                                    onClick={() => {
                                        this.toggleJsonPanel();
                                    }}
                                    style={{ marginTop: '10px' }}
                                />
                            </Panel>
                        </div>
                    }
                    {/*BASED ON SCORECARD*/}
                    {this.state.basedOn === "Scorecard" &&
                        <Query
                            query={queryScorecardsLabels}
                            variables={{}}
                        >
                            {({ loading, error, data }) => {
                                if (loading) return (<Spinner label="Still loading..." ariaLive="assertive" labelPosition="top" />);
                                if (error) return <h4>Failed to connect</h4>;
                                if (data.getScorecards == null) return <div />;
                                const availableScorecards = data.getScorecards.map(s => {
                                    return { key: s.masterItemId, text: s.name }
                                })
                                return <div>
                                    <ComboBox
                                        id={"scorecardDropdown"}
                                        placeholder={this.context.getTranslation("compliance", "selectAIScorecard")}
                                        selectedKey={this.state.scorecardId}
                                        allowFreeform={false}
                                        onChange={(e, i) => {
                                            this.checkScorecard(i.key)
                                        }}
                                        autoComplete={true}
                                        options={availableScorecards}
                                    />
                                    <Dropdown
                                        multiSelect
                                        selectedKeys={this.state.conversationType}
                                        options={[
                                            { key: 'Inbound', text: this.context.getTranslation("filterPanel", "inbound") },
                                            { key: 'Outbound', text: this.context.getTranslation("filterPanel", "outbound") },
                                            { key: 'Meeting', text: this.context.getTranslation("filterPanel", "meetings") },
                                            { key: 'Internal', text: this.context.getTranslation("filterPanel", "internal") },
                                            //{ key: 'External', text: this.context.getTranslation("filterPanel", "external") },
                                            { key: 'Chat', text: this.context.getTranslation("configuration", "chat") },
                                            { key: 'Upload', text: this.context.getTranslation("filterPanel", "upload") },
                                            { key: 'Mail', text: this.context.getTranslation("configuration", "mail") }
                                        ]}
                                        onChange={(event, item) => {
                                            if (item) {
                                                this.setState({
                                                    conversationType: item.selected ? [...this.state.conversationType, item.key] : this.state.conversationType.filter(key => key !== item.key),
                                                    selectedOtherVersion: false,
                                                });
                                            }
                                        }}
                                        autoComplete={true}
                                        allowFreeform={false}
                                        label={this.context.getTranslation("conversationsPage", "conversationType")}
                                        placeholder={this.context.getTranslation("conversationsPage", "selectConversationType")}
                                    />
                                </div>
                            }}
                        </Query>
                    }
                </Stack>
                {/*CHANNEL*/}
                <h5>{this.context.getTranslation("compliance", "detailPolicyChannel")}</h5>
                <Stack style={{ marginTop: "10px" }} horizontal tokens={numericalSpacingStackTokens}>
                    <Checkbox
                        label={this.context.getTranslation("compliance", "text")}
                        checked={this.state.channelList == null || this.state.channelList === undefined
                            ? (this.state.channel === "Text" || this.state.channel === "Both")
                            : this.state.channelList.includes("Text")}
                        onChange={(event, checked) => this.onChangeChannel(event, checked, "Text")}
                    />
                    <Checkbox
                        label={this.context.getTranslation("compliance", "voice")}
                        checked={this.state.channelList == null || this.state.channelList === undefined
                            ? (this.state.channel === "Voice" || this.state.channel === "Both")
                            : this.state.channelList.includes("Voice")}
                        onChange={(event, checked) => this.onChangeChannel(event, checked, "Voice")}
                    />
                    <Checkbox
                        label={this.context.getTranslation("compliance", "screenshare")}
                        checked={this.state.channelList == null || this.state.channelList === undefined
                            ? false
                            : this.state.channelList.includes("Screen")}
                        onChange={(event, checked) => this.onChangeChannel(event, checked, "Screen")}
                    />
                    <Checkbox
                        label={this.context.getTranslation("compliance", "mail")}
                        checked={this.state.channelList == null || this.state.channelList === undefined
                            ? false
                            : this.state.channelList.includes("Mail")}
                        onChange={(event, checked) => this.onChangeChannel(event, checked, "Mail")}
                    />
                </Stack>
                {/*POLICY WORKFLOW*/}
                {this.props.userRules.ruleAccess.userCompliancePolicyInitiateWorkflow && this.props.userRules.ruleAccess.userSafe != "No" && this.state.basedOn !== "Scorecard" && this.state.basedOn !== "AIAssistant" && this.state.basedOn !== "ContentUnderstanding" &&
                    <div>
                        <h5>{this.context.getTranslation("compliance", "detailPolicyFoldersTitle")}</h5>
                        <PolicyCSFolders
                            apol={this.props.apol}
                            selectedFolders={this.state?.conversationSafeFolders ?? []}
                            onChangePolicyFolders={this.onChangePolicyFolders}
                            userRules={this.props.userRules}
                            policyId={this.state.id}
                        />
                        <TextField label={this.context.getTranslation("compliance", "action")} value={this.state.hitAction} onChange={this.changeHitAction} />
                    </div>
                }
                {/*Policy AI Language*/}
                {this.state.browserDefaultLanguage != undefined && <div>
                    <h5>{this.context.getTranslation("compliance", "detailPolicyAILanguageAnswer")}</h5>
                    <Stack style={{ marginTop: "-8px" }}>
                        <Dropdown
                            placeholder={this.state.aILanguageAnswer}
                            options={[{ "key": "-1", "text": this.context.getTranslation("compliance", "aIAssistantAutoDetectLanguage") }, ...this.state.languageOptions].sort((a, b) => a.text.localeCompare(b.text))}
                            onChange={this.handleLanguageChange}
                        />
                    </Stack>
                </div>
                }
                {/*Transcript Language*/}
                {(this.state.basedOn === "ContentUnderstanding") &&
                    <Stack>
                        <div style={{ border: 0, height: '2px', backgroundColor: '#ccc', marginTop: 10 }}></div>
                        <h5>{this.context.getTranslation("compliance", "detailPolicyTranscriptLanguage")}</h5>
                        <Stack.Item>
                            <TranscriptLanuages
                                label={this.context.getTranslation("configuration", "defaultLanguage")}
                                selectedKey={this.state.cuTranscriptLanguage}
                                onChange={(e, option) => {
                                    if (option.key == "") {
                                        this.setState({ cuTranscriptLanguage: option.key })
                                    } else {
                                        var selectedAltLangaugeIndex = this.state.cuOptionAlternativeLanguageKey.indexOf(option.key);
                                        var newAltLanguage = this.state.cuOptionAlternativeLanguageKey;
                                        if (selectedAltLangaugeIndex > -1) {
                                            newAltLanguage.splice(selectedAltLangaugeIndex, 1);
                                        }
                                        this.setState({
                                            cuTranscriptLanguage: option.key,
                                            cuOptionAlternativeLanguageKey: newAltLanguage
                                        });
                                    }
                                }
                                }
                                placeholder={this.context.getTranslation("common", "selectAnOption")}
                            />
                        </Stack.Item>
                        {this.state.cuTranscriptLanguage &&
                            <Stack.Item>
                                <Checkbox
                                    label={this.context.getTranslation("configuration", "addAlternativeLanguage")}
                                    checked={this.state.cuAlternativeLanguage}
                                    styles={checkboxStyles}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            cuAlternativeLanguage: newValue,
                                            updated: true
                                        });
                                    }}
                                />
                            </Stack.Item>
                        }
                        {this.state.cuAlternativeLanguage && <>
                            <Stack.Item>
                                <Query
                                    query={getCognitiveServicesLocalesTranscription}
                                    variables={{}}
                                >
                                    {({ loading, error, data }) => {
                                        if (loading) {
                                            return (
                                                <div style={{ float: "left", "margin-left": "50px" }}>
                                                    <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                                                </div>
                                            );
                                        }
                                        if (error) return <h4>Failed to connect</h4>;
                                        if (data.getTranscriptionLocales == null) {
                                            return <div />;
                                        }
                                        let transcriptLanguageList = [];

                                        if (data.getTranscriptionLocales != null) {

                                            let languageNames = new Intl.DisplayNames(['en'], { type: 'language' });
                                            for (var i = 0; i < data.getTranscriptionLocales.length; i++) {
                                                var countryName = languageNames.of(data.getTranscriptionLocales[i]);
                                                transcriptLanguageList.push({
                                                    key: data.getTranscriptionLocales[i],
                                                    text: countryName
                                                });
                                            }
                                        }

                                        return <ComboBox
                                            placeholder={"Select maximum " + this.state.maxAlternativeLanguages + " languages"}
                                            id="selectAlternativeLanguage"
                                            style={{ width: "300px" }}
                                            label={this.context.getTranslation("configuration", "selectAlternativeLanguage")}
                                            selectedKey={this.state.cuOptionAlternativeLanguageKey}
                                            allowFreeform={false}
                                            onChange={this.onChangeMultiLanguages}
                                            autoComplete={true}
                                            options={this.availableAlternativeLanguages(transcriptLanguageList)}
                                            errorMessage={this.state.cuOptionAlternativeLanguageKey.length > this.state.maxAlternativeLanguages ? ('Maximum ' + (this.state.maxAlternativeLanguages) + ' alternative languages') : undefined}
                                            multiSelect

                                        />

                                    }}

                                </Query>


                            </Stack.Item>
                        </>}
                        <div style={{ border: 0, height: '2px', backgroundColor: '#ccc', marginTop: 10 }}></div>
                    </Stack>
                }
                {/*RISK RATING*/}
                {this.state.basedOn != "AIAssistant" && this.state.basedOn != "ContentUnderstanding" && <div>
                    <h5 style={this.state.basedOn === "Scorecard" ? { color: "#595959" } : {}}>
                        {this.context.getTranslation("compliance", "detailPolicyRiskRating")}
                    </h5>
                    <Stack style={{ marginTop: "10px" }} horizontal tokens={numericalSpacingStackTokens}>
                        <Checkbox
                            label={this.context.getTranslation("compliance", "riskRatingInformation")}
                            id={"Info"}
                            checked={this.state.riskRating === "Info"}
                            onChange={this.onChangeRiskRating}
                            disabled={this.state.basedOn === "Scorecard"}
                        />
                        <Checkbox
                            label={this.context.getTranslation("compliance", "riskRatingAdherence")}
                            id={"Adherence"}
                            checked={this.state.riskRating === "Adherence"}
                            onChange={this.onChangeRiskRating}
                            disabled={this.state.basedOn === "Scorecard"}
                        />
                        <Checkbox
                            label={this.context.getTranslation("compliance", "riskRatingWarning")}
                            id={"Warning"}
                            checked={this.state.riskRating === "Warn"}
                            onChange={this.onChangeRiskRating}
                            disabled={this.state.basedOn === "Scorecard"}
                        />
                    </Stack>
                </div>}
                {/*ASSIGN TO*/}
                {this.state.basedOn != "ContentUnderstanding" && <div>

                    <h5>{this.context.getTranslation("compliance", "detailPolicyUsers")}</h5>
                    {
                        !this.state.selectedUsersAndGroup.reduce((acc, cur) => {
                            const userObj = this.state?.userdata?.find(e => e.id == cur);
                            const curMember = userObj?.members?.split(",");
                            // Main user compliance
                            const mainUserCompliant = (userObj?.addOnCompliance === true || userObj?.license === "10");
                            // All group members compliance
                            const allMembersCompliant = (
                                this.state?.userdata
                                    ?.filter(e => curMember?.includes(e.id))
                                    .filter(x => !(x.addOnCompliance === true || x.license === "10"))
                                    .length === 0
                            );
                            return acc && (mainUserCompliant && allMembersCompliant);
                        }, true)
                        && <AlertNoAddOnCompliance />
                    }

                    <UserPicker
                        editPolicy={true}
                        passUserDataToParent={({ userdata }) => this.setState({ userdata })}
                        userdata={this.state.userdata}
                        placeholder={this.context.getTranslation("compliance", "selectUserOrGroup")}
                        user={(() => {
                            // add elements from metaAssign to selectedUsersAndGroup only those who are not yet present,
                            // we do so by finding metaUsers in selectedUsersAndGroup, then we filter.

                            // let metaUsersThatAreNotInUsersYet = [...this.state.metaAssigneeUsersDeleted.filter(metaUser => !this.state.selectedUsersAndGroup.find(e=>e.userId===metaUser))]
                            return [...this.state.selectedUsersAndGroup.map(user => ({ "userId": user }))]
                        })()}
                        fc={(users, peopleList) => {
                            let usersFromPicker = [...users]
                            let newUsersForPicker = usersFromPicker.sort((a, b) => {
                                const aCompliant = a.addOnCompliance || a.license === "10";
                                const bCompliant = b.addOnCompliance || b.license === "10";
                                if (aCompliant && !bCompliant) return 1;
                                else if (aCompliant && bCompliant) return 0;
                                else return -1;
                            }).map(u => u.userId)
                            this.setState({
                                //all users in assignee list have add on compliance or license 10
                                deleteNoAOCUsersBulk: usersFromPicker.filter(u => !(u.addOnCompliance || u.license === "10")).length,
                                allAssigneeHaveAOC: !(usersFromPicker.filter(u => !(u.addOnCompliance || u.license === "10")).length),
                                selectedUsersAndGroup: [...newUsersForPicker,],
                                selectedOtherVersion: false,
                                // metaAssigneeUsersDeleted: usersFromMetaAssigneeThatRemain
                            });
                        }}

                    />
                </div>}
                {/*MONITORED BY*/}
                {this.state.basedOn === "Scorecard" && <div>
                    <h5>{this.context.getTranslation("compliance", "detailPolicySupervisor")}</h5>
                    {!this.state.allMonitorsHaveAOC &&
                        <AlertNoAddOnCompliance />
                    }

                    <UserPicker
                        editPolicy={true}
                        placeholder={this.context.getTranslation("compliance", "selectUserOrGroup")}
                        user={this.state.selectedSupervisors.map(user => {
                            return ({
                                "userId": user
                            })
                        })}
                        fc={(users, peopleList) => {
                            let usersFromPicker = [...users];
                            let newUsersForPicker = usersFromPicker.sort((a, b) => {
                                const aCompliant = a.addOnCompliance || a.license === "10";
                                const bCompliant = b.addOnCompliance || b.license === "10";
                                if (aCompliant && !bCompliant) return 1;
                                else if (aCompliant && bCompliant) return 0;
                                else return -1;
                            }).map(u => u.userId);

                            let allMonitorsHaveAOC = usersFromPicker.reduce((acc, cur) => {
                                let curMember = this.state?.userdata?.find(e => e.id == cur.key).members?.split(",");
                                const mainUserCompliant = (this.state?.userdata?.find(e => e.id == cur.key)?.addOnCompliance === true
                                    || this.state?.userdata?.find(e => e.id == cur.key)?.license === "10");
                                const allMembersCompliant = (
                                    this.state?.userdata
                                        ?.filter(e => curMember?.includes(e.id))
                                        .filter(x => !(x.addOnCompliance === true || x.license === "10"))
                                        .length === 0
                                );
                                return acc && (mainUserCompliant && allMembersCompliant);
                            }, true);

                            this.setState({
                                //all users in assignee list have add on compliance or license 10
                                deleteNoAOCUsersBulkMonitor: usersFromPicker.filter(u => !(u.addOnCompliance || u.license === "10")).length,
                                allMonitorsHaveAOC: allMonitorsHaveAOC,
                                selectedSupervisors: [...newUsersForPicker],
                                selectedOtherVersion: false,
                                // metaAssigneeUsersDeleted: usersFromMetaAssigneeThatRemain
                            });
                        }}
                    />
                </div>}
                {/*VISIBLE FOR USERS */}
                {this.state.basedOn != "AICategorization" && this.state.basedOn != "AIAssistant" && this.state.basedOn != "ContentUnderstanding" && <div>
                    <h5>{this.context.getTranslation("compliance", "policyVisibleForUsers")}</h5>
                    {!this.state.allVisibleForUsersHaveAOC &&
                        <AlertNoAddOnCompliance />
                    }
                    <UserPicker
                        editPolicy={true}
                        placeholder={this.context.getTranslation("compliance", "selectUserOrGroup")}
                        user={this.state.visibleForUsers.map(user => {
                            return ({
                                "userId": user
                            })
                        })}
                        fc={(users, peopleList) => {
                            let usersFromPicker = [...users];
                            let newUsersForPicker = usersFromPicker.sort((a, b) => {
                                const aCompliant = a.addOnCompliance || a.license === "10";
                                const bCompliant = b.addOnCompliance || b.license === "10";
                                if (aCompliant && !bCompliant) return 1;
                                else if (aCompliant && bCompliant) return 0;
                                else return -1;
                            }).map(u => u.userId);

                            if (users.length !== 0 && !newUsersForPicker.includes(this.props.userRules.userId))
                                newUsersForPicker = [this.props.userRules.userId, ...newUsersForPicker];

                            let allVisibleForUsersHaveAOC = usersFromPicker.reduce((acc, cur) => {
                                let curMember = this.state?.userdata?.find(e => e.id == cur.key).members?.split(",");
                                const mainUserCompliant = (this.state?.userdata?.find(e => e.id == cur.key)?.addOnCompliance === true
                                    || this.state?.userdata?.find(e => e.id == cur.key)?.license === "10");
                                const allMembersCompliant = (
                                    this.state?.userdata
                                        ?.filter(e => curMember?.includes(e.id))
                                        .filter(x => !(x.addOnCompliance === true || x.license === "10"))
                                        .length === 0
                                );
                                return acc && (mainUserCompliant && allMembersCompliant);
                            }, true);

                            this.setState({
                                //all users in visibleForUsers list have add on compliance or license 10
                                deleteNoAOCUsersBulkMonitor: usersFromPicker.filter(u => !(u.addOnCompliance || u.license === "10")).length,
                                allVisibleForUsersHaveAOC: allVisibleForUsersHaveAOC,
                                visibleForUsers: [...newUsersForPicker],
                                selectedOtherVersion: false,
                                // metaAssigneeUsersDeleted: usersFromMetaAssigneeThatRemain
                            });
                        }}
                    />
                </div>}
                {/*ACTIVE*/}
                {this.state.basedOn != "ContentUnderstanding" &&
                    <Stack style={{ marginTop: "20px" }} horizontal>
                        <Checkbox label={this.context.getTranslation("compliance", "detailPolicyActive")} checked={this.state.active} onChange={this.onChangeActive} disabled={!this.props.userRules.ruleAccess.userCompliancePolicyActivate} />
                    </Stack>
                }
                {/*ENABLE ALERTS*/}
                {this.state.basedOn == "Scorecard" &&
                    <Stack style={{ marginTop: "20px" }} horizontal>
                        <Checkbox id={"enableAlerts"} label={this.context.getTranslation("compliance", "enableAlerts")} checked={this.state.alertsEnabled} onChange={this.checkAlerts} disabled={this.state.scorecardId === null} />
                    </Stack>
                }
                {this.state.alertsEnabled &&
                    <Stack>
                        <ChoiceGroup
                            style={{ marginTop: "10px" }}
                            selectedKey={this.state.alarmAgents}
                            options={this.alarmOpt()}
                            onChange={(e, option) => this.setState({
                                alarmAgents: option.key
                            })}
                        />
                        {this.state.alarmAgents == "perAgent" &&
                            <UserPicker
                                editPolicy={true}
                                assignTo={this.state.selectedUsersAndGroup}
                                placeholder={this.context.getTranslation("compliance", "selectUserOrGroup")}
                                user={(() => {
                                    // add elements from metaAssign to selectedUsersAndGroup only those who are not yet present,
                                    // we do so by finding metaUsers in selectedUsersAndGroup, then we filter.

                                    // let metaUsersThatAreNotInUsersYet = [...this.state.metaAssigneeUsersDeleted.filter(metaUser => !this.state.selectedUsersAndGroup.find(e=>e.userId===metaUser))]
                                    return [...this.state.selectedAgents.map(user => ({ "userId": user }))]
                                })()}
                                fc={(users, peopleList) => {
                                    let usersFromPicker = [...users]
                                    let newUsersForPicker = usersFromPicker.sort((a, b) => {
                                        if (a.addOnCompliance && !b.addOnCompliance) return 1
                                        else if (a.addOnCompliance && b.addOnCompliance) return 0
                                        else return -1
                                    }).map(u => u.userId)
                                    this.setState({
                                        selectedAgents: [...newUsersForPicker],
                                        selectedOtherVersion: false

                                    });
                                }}

                            />
                        }
                        <div style={{ marginTop: 10 }}>
                            <Dropdown
                                label={this.context.getTranslation("compliance", "minAlarmScore")}
                                placeholder={this.state.scorecardAlarmSettingItems[0]?.text}
                                selectedKey={this.state.alarmScoreValue}
                                onChange={this.onChangeMinAlarmScore}
                                options={this.state.scorecardAlarmSettingItems}
                            />
                        </div>
                        <Stack
                            horizontal
                            tokens={{ childrenGap: 1 }}
                            verticalAlign="center"
                        >
                            <Stack.Item grow={1}>
                                <Dropdown
                                    label={this.context.getTranslation("compliance", "evaluateSpecificSections")}
                                    placeholder={this.context.getTranslation("compliance", "selectSection")}
                                    selectedKey={this.state.selectedSection}
                                    onChange={this.onChangeSection}
                                    options={this.state.scorecardAlarmSections}
                                />
                            </Stack.Item>
                            <Stack.Item>
                                <CommandBarButton style={{ marginLeft: "10px", marginTop: "29px", padding: "9px" }}
                                    text={this.context.getTranslation("compliance", "addSection")}
                                    iconProps={{ iconName: 'Add' }}
                                    onClick={this.addSection} />
                            </Stack.Item>
                        </Stack>
                        <Stack tokens={{ childrenGap: 10 }} style={{ marginTop: "20px" }}>
                            {this.state.alarmSections.map((card, index) => (
                                <DocumentCard key={card.key} styles={{ root: { maxWidth: 600, padding: "3px 13px 13px 13px" } }}>
                                    <DocumentCardDetails>
                                        <Stack
                                            tokens={{ childrenGap: 5 }}>
                                            <Stack
                                                horizontal
                                                tokens={{ childrenGap: 5 }}
                                                verticalAlign="center"
                                            >
                                                <Stack.Item grow>
                                                    <h4 style={{ margin: 0 }}>{card.text}</h4>
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <IconButton
                                                        iconProps={{ iconName: 'Delete' }}
                                                        onClick={() => this.deleteSection(card.key)}
                                                    />
                                                </Stack.Item>
                                            </Stack>
                                            <Stack
                                                horizontal
                                                tokens={{ childrenGap: 12 }}
                                                verticalAlign="center"
                                            >
                                                <Stack.Item grow>
                                                    <Dropdown
                                                        label={this.context.getTranslation("compliance", "evaluateSpecificSections")}
                                                        placeholder={this.state.scorecardAlarmSettingItems[0]?.text}
                                                        selectedKey={this.state.alarmSections.find(section => section.key === card.key).minScore}
                                                        onChange={(e, option) => this.onChangeScoreSelectedSection(card.key, option)}
                                                        options={this.state.scorecardAlarmSettingItems}
                                                    />
                                                </Stack.Item>
                                            </Stack>
                                        </Stack>
                                    </DocumentCardDetails>
                                </DocumentCard>
                            ))}
                        </Stack>
                        <Stack>
                            <div>{this.context.getTranslation("compliance", "selectPeriod")}</div>
                            <Dropdown
                                placeholder={this.context.getTranslation("compliance", "selectSection")}
                                selectedKey={this.state.alarmPeriodSelection}
                                onChange={this.onChangePeriod}
                                options={this.state.periodChoices}
                                styles={{ root: { maxWidth: 200 } }}
                            />
                        </Stack>
                        {(this.state.alarmPeriodSelection && this.state.alarmPeriodSelection !== "once") &&
                            <Stack
                                horizontal
                                verticalAlign="center"
                                style={{ marginTop: "10px" }}
                            >
                                <DatePicker
                                    placeholder={this.context.getTranslation("compliance", "scheduleStartTime")}
                                    styles={{ root: { maxWidth: 200 } }}
                                    value={this.state.selectedStartDate}
                                    onSelectDate={(date) => this.setState({ selectedStartDate: date })}
                                    minDate={new Date()}

                                />
                                <span style={{ margin: "0 10px" }}>
                                    {this.context.getTranslation("compliance", "scheduleSeparator")}
                                </span>
                                <DatePicker
                                    placeholder={this.context.getTranslation("compliance", "scheduleEndTime")}
                                    styles={{ root: { maxWidth: 200 } }}
                                    value={this.state.selectedEndDate}
                                    onSelectDate={(date) => this.setState({ selectedEndDate: date })}
                                    minDate={new Date()}

                                />
                            </Stack>
                        }
                        {this.state.alarmPeriodSelection && this.state.alarmPeriodSelection == "weekly" &&
                            <ChoiceGroup
                                style={{ marginTop: "10px" }}
                                selectedKey={this.state.dayChoice}
                                options={this.state.alarmDayChoices}
                                onChange={(e, option) => this.setState({
                                    dayChoice: option.key
                                })}
                            />
                        }
                        <div
                            style={{ marginTop: "10px", marginBottom: "5px" }}>
                            <h5 style={{ margin: 0 }}>{this.context.getTranslation("compliance", "notificationEmail")}</h5>
                        </div>

                        <UserPicker
                            editPolicy={true}
                            placeholder={this.context.getTranslation("compliance", "selectUserOrGroup")}
                            user={(() => {
                                // add elements from metaAssign to selectedUsersAndGroup only those who are not yet present,
                                // we do so by finding metaUsers in selectedUsersAndGroup, then we filter.

                                // let metaUsersThatAreNotInUsersYet = [...this.state.metaAssigneeUsersDeleted.filter(metaUser => !this.state.selectedUsersAndGroup.find(e=>e.userId===metaUser))]
                                return [...this.state.agentsToNotify.map(u => ({
                                    "userId": u.userId
                                }))]
                            })()}
                            fc={(users, peopleList) => {
                                let usersFromPicker = [...users]
                                let newUsersForPicker = usersFromPicker.sort((a, b) => {
                                    if (a.addOnCompliance && !b.addOnCompliance) return 1
                                    else if (a.addOnCompliance && b.addOnCompliance) return 0
                                    else return -1
                                }).map(u => ({
                                    userId: u.userId,
                                    email: u.email
                                }));
                                this.setState({
                                    agentsToNotify: [...newUsersForPicker,]
                                });
                            }}

                        />
                    </Stack>

                }


                {this.state.showTeachingBubbleBasedOn &&
                    <Layer>
                        <TeachingBubble
                            target="#basedOnLabel"
                            primaryButtonProps={{
                                children: this.context.getTranslation("common", "yes"),
                                onClick: () => {
                                    this.setState({
                                        basedOn: this.state.preSelectedbasedOn,
                                        aILanguageAnswer: this.state.preSelectedbasedOn === 'PolicyRule' ? "None" : this.getAILanguageAnswer(this.state.languageOptions, this.state.browserDefaultLanguage),
                                        riskRating: this.state.preSelectedbasedOn === 'Scorecard' ? "None" : this.state.riskRating,
                                        selectedOtherVersion: false,
                                        showTeachingBubbleBasedOn: false,
                                        alertsEnabled: false
                                    })
                                }
                            }}
                            secondaryButtonProps={{
                                children: this.context.getTranslation("common", "no"),
                                onClick: () => {
                                    this.setState({ showTeachingBubbleBasedOn: false });
                                }
                            }}
                            hasCloseButton
                            onDismiss={() => this.setState({ showTeachingBubbleBasedOn: false })}
                        >
                            {this.context.getTranslation("compliance", "alertPolicyAlarmLoss")}
                        </TeachingBubble>
                    </Layer>
                }

                {this.state.showTeachingBubbleScorecardDropdown &&
                    <Layer>
                        <TeachingBubble
                            target="#scorecardDropdown"
                            primaryButtonProps={{
                                children: this.context.getTranslation("common", "yes"),
                                onClick: () => {
                                    this.setState({
                                        showTeachingBubbleScorecardDropdown: false,
                                        scorecardId: this.state.preSelectedScorecard,
                                        selectedOtherVersion: false,
                                    })
                                }
                            }}
                            secondaryButtonProps={{
                                children: this.context.getTranslation("common", "no"),
                                onClick: () => {
                                    this.setState({ showTeachingBubbleScorecardDropdown: false });
                                }
                            }}
                            hasCloseButton
                            onDismiss={() => this.setState({ showTeachingBubbleScorecardDropdown: false })}
                        >
                            {this.context.getTranslation("compliance", "alertPolicyAlarmLossScorecardChange")}
                        </TeachingBubble>
                    </Layer>
                }

                {this.state.showTeachingBubbleCheckbox &&
                    <Layer>
                        <TeachingBubble
                            target="#enableAlerts"
                            primaryButtonProps={{
                                children: this.context.getTranslation("common", "yes"),
                                onClick: () => {
                                    this.setState({
                                        showTeachingBubbleCheckbox: false,
                                        alertsEnabled: !this.state.alertsEnabled
                                    })
                                }
                            }}
                            secondaryButtonProps={{
                                children: this.context.getTranslation("common", "no"),
                                onClick: () => {
                                    this.setState({ showTeachingBubbleCheckbox: false });
                                }
                            }}
                            hasCloseButton
                            onDismiss={() => this.setState({ showTeachingBubbleCheckbox: false })}
                        >
                            {this.context.getTranslation("compliance", "alertPolicyAlarmLossDisableCheckBox")}
                        </TeachingBubble>
                    </Layer>
                }

                {/*FOOTER BUTTONS*/}
                <Stack horizontal style={{ flexFlow: "row-reverse" }}>
                    <DefaultButton text={this.context.getTranslation("common", "cancel")} onClick={this.cancel} style={{ marginTop: "30px", marginLeft: "15px" }} disabled={this.state.processing} />
                    {(!this.state.selectedOtherVersion || this.state.id === this.state.selectedVersion) &&
                        <PrimaryButton text={this.context.getTranslation("common", "save")} id={"saveButton"} onClick={this.save} style={{ marginTop: "30px", marginLeft: "15px" }} disabled={!this.isValid() || this.state.processing} />
                    }
                    {this.state.selectedOtherVersion && this.state.id !== this.state.selectedVersion &&
                        <PrimaryButton text={this.context.getTranslation("compliance", "restoreVersion")} onClick={this.restoreVersion} style={{ marginTop: "30px", marginLeft: "15px" }} disabled={!this.isValid() || this.state.processing} />
                    }
                </Stack>
            </div>
            }
        </div>
        )
    }


}
